// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1rFPX","checkboxCol":"Table_checkboxCol__9qI1y","emailCol":"Table_emailCol__69Tuj","actionCol":"Table_actionCol__2P77p"};